/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ClientSkipTakeAndCountDto } from '../model/clientSkipTakeAndCountDto';
import { Clients } from '../model/clients';
import { ProblemDetails } from '../model/problemDetails';
import { Rate } from '../model/rate';
import { ServiceClientMapDto } from '../model/serviceClientMapDto';
import { ServiceClients } from '../model/serviceClients';
import { ServiceClientsDto } from '../model/serviceClientsDto';
import { ServicesDto } from '../model/servicesDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class MapServiceToClientService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param serviceName 
     * @param clientId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapServiceToClientGetAllByClientIdAndServiceNameGet(serviceName?: string, clientId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceClients>>;
    public apiMapServiceToClientGetAllByClientIdAndServiceNameGet(serviceName?: string, clientId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceClients>>>;
    public apiMapServiceToClientGetAllByClientIdAndServiceNameGet(serviceName?: string, clientId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceClients>>>;
    public apiMapServiceToClientGetAllByClientIdAndServiceNameGet(serviceName?: string, clientId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceName !== undefined && serviceName !== null) {
            queryParameters = queryParameters.set('serviceName', <any>serviceName);
        }
        if (clientId !== undefined && clientId !== null) {
            queryParameters = queryParameters.set('clientId', <any>clientId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ServiceClients>>('get',`${this.basePath}/api/MapServiceToClient/GetAllByClientIdAndServiceName`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param clientId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapServiceToClientGetAllByClientIdGet(clientId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceClientMapDto>>;
    public apiMapServiceToClientGetAllByClientIdGet(clientId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceClientMapDto>>>;
    public apiMapServiceToClientGetAllByClientIdGet(clientId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceClientMapDto>>>;
    public apiMapServiceToClientGetAllByClientIdGet(clientId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientId !== undefined && clientId !== null) {
            queryParameters = queryParameters.set('clientId', <any>clientId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ServiceClientMapDto>>('get',`${this.basePath}/api/MapServiceToClient/GetAllByClientId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapServiceToClientGetAllByServiceIdGet(serviceId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceClients>>;
    public apiMapServiceToClientGetAllByServiceIdGet(serviceId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceClients>>>;
    public apiMapServiceToClientGetAllByServiceIdGet(serviceId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceClients>>>;
    public apiMapServiceToClientGetAllByServiceIdGet(serviceId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceId !== undefined && serviceId !== null) {
            queryParameters = queryParameters.set('serviceId', <any>serviceId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ServiceClients>>('get',`${this.basePath}/api/MapServiceToClient/GetAllByServiceId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceName 
     * @param search 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapServiceToClientGetAllByServiceNameGet(serviceName?: string, search?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceClients>>;
    public apiMapServiceToClientGetAllByServiceNameGet(serviceName?: string, search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceClients>>>;
    public apiMapServiceToClientGetAllByServiceNameGet(serviceName?: string, search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceClients>>>;
    public apiMapServiceToClientGetAllByServiceNameGet(serviceName?: string, search?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceName !== undefined && serviceName !== null) {
            queryParameters = queryParameters.set('serviceName', <any>serviceName);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ServiceClients>>('get',`${this.basePath}/api/MapServiceToClient/GetAllByServiceName`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapServiceToClientGetAllByServiceProviderIdGet(serviceProviderId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceClients>>;
    public apiMapServiceToClientGetAllByServiceProviderIdGet(serviceProviderId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceClients>>>;
    public apiMapServiceToClientGetAllByServiceProviderIdGet(serviceProviderId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceClients>>>;
    public apiMapServiceToClientGetAllByServiceProviderIdGet(serviceProviderId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ServiceClients>>('get',`${this.basePath}/api/MapServiceToClient/GetAllByServiceProviderId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param skip 
     * @param take 
     * @param search 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapServiceToClientGetAllClientsBySpIdAndSearchGet(serviceProviderId?: string, skip?: number, take?: number, search?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiMapServiceToClientGetAllClientsBySpIdAndSearchGet(serviceProviderId?: string, skip?: number, take?: number, search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiMapServiceToClientGetAllClientsBySpIdAndSearchGet(serviceProviderId?: string, skip?: number, take?: number, search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiMapServiceToClientGetAllClientsBySpIdAndSearchGet(serviceProviderId?: string, skip?: number, take?: number, search?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/MapServiceToClient/GetAllClientsBySpIdAndSearch`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapServiceToClientGetAllClientsMappedToSPSercicesByServiceProviderIdGet(serviceProviderId?: string, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiMapServiceToClientGetAllClientsMappedToSPSercicesByServiceProviderIdGet(serviceProviderId?: string, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiMapServiceToClientGetAllClientsMappedToSPSercicesByServiceProviderIdGet(serviceProviderId?: string, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiMapServiceToClientGetAllClientsMappedToSPSercicesByServiceProviderIdGet(serviceProviderId?: string, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/api/MapServiceToClient/GetAllClientsMappedToSPSercicesByServiceProviderId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param authId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapServiceToClientGetAllClientsServicesGet(authId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ServicesDto>>;
    public apiMapServiceToClientGetAllClientsServicesGet(authId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServicesDto>>>;
    public apiMapServiceToClientGetAllClientsServicesGet(authId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServicesDto>>>;
    public apiMapServiceToClientGetAllClientsServicesGet(authId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (authId !== undefined && authId !== null) {
            queryParameters = queryParameters.set('authId', <any>authId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ServicesDto>>('get',`${this.basePath}/api/MapServiceToClient/GetAllClientsServices`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapServiceToClientGetAllGet(observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceClients>>;
    public apiMapServiceToClientGetAllGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceClients>>>;
    public apiMapServiceToClientGetAllGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceClients>>>;
    public apiMapServiceToClientGetAllGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ServiceClients>>('get',`${this.basePath}/api/MapServiceToClient/GetAll`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapServiceToClientGetAllMappedClientToSpServicesBySPIdDropdownGet(id?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Clients>>;
    public apiMapServiceToClientGetAllMappedClientToSpServicesBySPIdDropdownGet(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Clients>>>;
    public apiMapServiceToClientGetAllMappedClientToSpServicesBySPIdDropdownGet(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Clients>>>;
    public apiMapServiceToClientGetAllMappedClientToSpServicesBySPIdDropdownGet(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Clients>>('get',`${this.basePath}/api/MapServiceToClient/GetAllMappedClientToSpServicesBySPIdDropdown`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param search 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapServiceToClientGetAllMappedClientToSpServicesByserviceProviderIAndSearchGet(id?: string, search?: string, observe?: 'body', reportProgress?: boolean): Observable<ClientSkipTakeAndCountDto>;
    public apiMapServiceToClientGetAllMappedClientToSpServicesByserviceProviderIAndSearchGet(id?: string, search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientSkipTakeAndCountDto>>;
    public apiMapServiceToClientGetAllMappedClientToSpServicesByserviceProviderIAndSearchGet(id?: string, search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientSkipTakeAndCountDto>>;
    public apiMapServiceToClientGetAllMappedClientToSpServicesByserviceProviderIAndSearchGet(id?: string, search?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ClientSkipTakeAndCountDto>('get',`${this.basePath}/api/MapServiceToClient/GetAllMappedClientToSpServicesByserviceProviderIAndSearch`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param _id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapServiceToClientGetByIdGet(_id?: string, observe?: 'body', reportProgress?: boolean): Observable<ServiceClients>;
    public apiMapServiceToClientGetByIdGet(_id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceClients>>;
    public apiMapServiceToClientGetByIdGet(_id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceClients>>;
    public apiMapServiceToClientGetByIdGet(_id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (_id !== undefined && _id !== null) {
            queryParameters = queryParameters.set('_id', <any>_id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ServiceClients>('get',`${this.basePath}/api/MapServiceToClient/GetById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceName 
     * @param clientName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapServiceToClientGetClientServiceByServiceNameAndClientNameGet(serviceName?: string, clientName?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceClients>>;
    public apiMapServiceToClientGetClientServiceByServiceNameAndClientNameGet(serviceName?: string, clientName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceClients>>>;
    public apiMapServiceToClientGetClientServiceByServiceNameAndClientNameGet(serviceName?: string, clientName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceClients>>>;
    public apiMapServiceToClientGetClientServiceByServiceNameAndClientNameGet(serviceName?: string, clientName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceName !== undefined && serviceName !== null) {
            queryParameters = queryParameters.set('serviceName', <any>serviceName);
        }
        if (clientName !== undefined && clientName !== null) {
            queryParameters = queryParameters.set('clientName', <any>clientName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ServiceClients>>('get',`${this.basePath}/api/MapServiceToClient/GetClientServiceByServiceNameAndClientName`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param spName 
     * @param clientName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapServiceToClientGetClientServiceByServiceProviderNameAndClientNameGet(spName?: string, clientName?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceClients>>;
    public apiMapServiceToClientGetClientServiceByServiceProviderNameAndClientNameGet(spName?: string, clientName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceClients>>>;
    public apiMapServiceToClientGetClientServiceByServiceProviderNameAndClientNameGet(spName?: string, clientName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceClients>>>;
    public apiMapServiceToClientGetClientServiceByServiceProviderNameAndClientNameGet(spName?: string, clientName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (spName !== undefined && spName !== null) {
            queryParameters = queryParameters.set('spName', <any>spName);
        }
        if (clientName !== undefined && clientName !== null) {
            queryParameters = queryParameters.set('clientName', <any>clientName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ServiceClients>>('get',`${this.basePath}/api/MapServiceToClient/GetClientServiceByServiceProviderNameAndClientName`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceName 
     * @param spName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapServiceToClientGetClientsNotMappedToThisServiceGet(serviceName?: string, spName?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Clients>>;
    public apiMapServiceToClientGetClientsNotMappedToThisServiceGet(serviceName?: string, spName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Clients>>>;
    public apiMapServiceToClientGetClientsNotMappedToThisServiceGet(serviceName?: string, spName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Clients>>>;
    public apiMapServiceToClientGetClientsNotMappedToThisServiceGet(serviceName?: string, spName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceName !== undefined && serviceName !== null) {
            queryParameters = queryParameters.set('serviceName', <any>serviceName);
        }
        if (spName !== undefined && spName !== null) {
            queryParameters = queryParameters.set('spName', <any>spName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Clients>>('get',`${this.basePath}/api/MapServiceToClient/GetClientsNotMappedToThisService`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param name 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapServiceToClientGetMappedClientsBySpNameGet(name?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Clients>>;
    public apiMapServiceToClientGetMappedClientsBySpNameGet(name?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Clients>>>;
    public apiMapServiceToClientGetMappedClientsBySpNameGet(name?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Clients>>>;
    public apiMapServiceToClientGetMappedClientsBySpNameGet(name?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('name', <any>name);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<Clients>>('get',`${this.basePath}/api/MapServiceToClient/GetMappedClientsBySpName`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapServiceToClientMapPost(body?: ServiceClientsDto, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiMapServiceToClientMapPost(body?: ServiceClientsDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiMapServiceToClientMapPost(body?: ServiceClientsDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiMapServiceToClientMapPost(body?: ServiceClientsDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/MapServiceToClient/Map`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param serviceName 
     * @param clientName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiMapServiceToClientRemoveDelete(body?: Array<Rate>, serviceName?: string, clientName?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiMapServiceToClientRemoveDelete(body?: Array<Rate>, serviceName?: string, clientName?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiMapServiceToClientRemoveDelete(body?: Array<Rate>, serviceName?: string, clientName?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiMapServiceToClientRemoveDelete(body?: Array<Rate>, serviceName?: string, clientName?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceName !== undefined && serviceName !== null) {
            queryParameters = queryParameters.set('serviceName', <any>serviceName);
        }
        if (clientName !== undefined && clientName !== null) {
            queryParameters = queryParameters.set('clientName', <any>clientName);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('delete',`${this.basePath}/api/MapServiceToClient/Remove`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
